import { createAction, props } from '@ngrx/store';
import { UserMasterState } from '../user-master-collection.state';

/**
 * Dispatched by the facade's `init()` to kick off resolution of the selected user: the
 * init effect hydrates from storage or, failing that, loads the candidates and drives the
 * selection modal.
 */
export const initUserMaster = createAction('[UserMaster] Init');

/**
 * Dispatched by the init effect once a user has been freshly selected (auto-selected or via
 * the modal). Carries the plain user for the reducer; the effect also persists it and pushes
 * the insights/client-manager side effects.
 */
export const userSelected = createAction('[UserMaster] User selected', props<{ user: UserMasterState }>());

/**
 * Dispatched by the init effect when a previously selected user was restored from storage.
 * Kept distinct from {@link userSelected} so a pure restore does not re-persist the value.
 */
export const userMasterRestored = createAction('[UserMaster] User restored', props<{ user: UserMasterState }>());

/**
 * Dispatched by the init effect when resolution fails. `hardFail` mirrors the legacy
 * `InitError` policy so the facade can re-throw a hard-failing `InitError` from `init()`.
 */
export const initUserMasterFailed = createAction(
    '[UserMaster] Init failed',
    props<{ hardFail: boolean; error: string }>(),
);

export const loadUserMasterFromBackend = createAction('[UserMaster] Load from backend');
